import { render, staticRenderFns } from "./CadastrarMedicoUnidade.vue?vue&type=template&id=504fb9f2"
import script from "./CadastrarMedicoUnidade.vue?vue&type=script&lang=js"
export * from "./CadastrarMedicoUnidade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports